import { AxiosResponse } from "axios";
import { api } from "../library/axios";
import { HanderResponse } from "../_base/helper/FunctionHelper";
import { API_ROUTE } from "../const/apiRoute";

export const getListProductAddOn = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_LIST_PRODUCT_ADD_ON + query
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
export const getListProductAddOnItemID = async (
  query: string
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_LIST_PRODUCT_ADD_ON_BY_ITEM_ID + query
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
